import React from 'react'
import { DeLoading } from '../DeLoading'

function Loader() {
    return (
        <div className="fixed z-50 w-full h-full">
            <span className="block mx-auto">
                <DeLoading />
            </span>
        </div>
    )
}

export default Loader